module.exports = __webpack_public_path__ + "static/img/ab_onboarding.17b9f39d.jpg";